export default __webpack_public_path__ + "static/media/pic2.f7b49e8f.jpg";